import React, { useEffect, useState } from "react";
import "./CameraView.css";
import Dialog from "../dialog/Dialog";
import CircleStatusIcon from "../../components/CircleStatusIcon";
import ArrowIcon from "../../components/ArrowIcon";

const CameraView = ({ cameradata, disk, isdiskconnected }) => {
  const [activeImgIndex, setActiveImgIndex] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [warningMessage, setWarningMessage] = useState("");
  const [actionMessage, setActionMessage] = useState("");

  const handleClose = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    if (!isdiskconnected) {
      setWarningMessage("Disk is not connected!!");
      setActionMessage(
        "To begin a new recording, turn off the ignition, connect a disk and then restart the system."
      );
    } else if (disk === 100) {
      setWarningMessage("Disk is full");
      setActionMessage(
        "To continue recording, turn off the ignition, unplugg and replace the full disk and then restart the system."
      );
    }
  }, [disk, isdiskconnected]);

  cameradata.sort(function (a, b) {
    const aNum = parseInt(a.name?.match(/\d+/)?.[0] ?? "");
    const bNum = parseInt(b.name?.match(/\d+/)?.[0] ?? "");
    return aNum - bNum;
  });

  return (
    <div className="relative">
      <div
        className={`flex flex-wrap items-center w-full scrolling ${activeImgIndex === null ? "px-[16px] pt-[24px]" : ""
          }`}
      >
        {activeImgIndex === null
          ? cameradata.map((item, i) => (
            <div
              className={`flex flex-col w-[424px] h-[478px] bg-grey-900 cursor-pointer mb-[16px] ${(i + 1) % 4 !== 0 ? "mr-[16px]" : ""
                }`}
              key={i}
              onClick={() => setActiveImgIndex(i)}
            >
              <div className="flex w-[408px] h-[398px] mx-[8px] mt-[8px]">
                <img src={item.image} id={item.name} alt="" />
              </div>
              <div className="flex justify-between  items-center mx-[21.5px] h-[80px]">
                <span className="text-sm text-light-1 font-scaniacondensed">
                  {item.name}
                </span>
                <CircleStatusIcon status={item.status} />
              </div>
            </div>
          ))
          : cameradata.map((item, i) => {
            return i === activeImgIndex ? (
              <div
                className="flex justify-center w-full h-full relative"
                key={i}
              >
                <div className="flex justify-around  items-center absolute top-[48px] w-[451px] h-[120px] bg-grey-800 rounded-[8px] ">
                  <button
                    className="flex justify-center items-center font-scaniacondensed text-lg rounded-[8px] w-1/4"
                    disabled={activeImgIndex === 0}
                    onClick={() =>
                      setActiveImgIndex((prevState) => prevState - 1)
                    }
                  >
                    <ArrowIcon
                      direction={"left"}
                      index={activeImgIndex}
                      length={cameradata.length}
                    />
                  </button>
                  <span className="text-light-1 text-lg font-scaniacondensed">
                    {" "}
                    {activeImgIndex + 1}/{cameradata.length}
                  </span>
                  <button
                    className="flex justify-center items-center font-scaniacondensed text-lg rounded-[8px] w-1/4"
                    disabled={activeImgIndex === cameradata.length - 1}
                    onClick={() =>
                      setActiveImgIndex((prevState) => prevState + 1)
                    }
                  >
                    <ArrowIcon
                      direction={"right"}
                      index={activeImgIndex}
                      length={cameradata.length}
                    />
                  </button>
                </div>
                <button
                  className="absolute top-[48px] right-[48px] w-[179px] h-[120px] bg-grey-868 text-md text-light-1 font-scaniacondensed rounded-[8px]"
                  onClick={() => setActiveImgIndex(null)}
                >
                  Close
                </button>
                <img src={item.image} id={item.name} alt="" />
              </div>
            ) : null;
          })}
      </div>
      {isVisible && (disk > 95 || !isdiskconnected) ? (
        <Dialog
          handleclose={handleClose}
          headermessage={warningMessage}
          actionmessage={actionMessage}
        />
      ) : null}
    </div>
  );
};

export default CameraView;
